// extracted by mini-css-extract-plugin
export var box = "Footer-module--box--PxXTx";
export var divider = "Footer-module--divider--TCQuH";
export var flags = "Footer-module--flags--GvOJm";
export var followUs = "Footer-module--followUs--ekhLR";
export var footer = "Footer-module--footer--ouARi";
export var footerNav = "Footer-module--footerNav--iNQsB";
export var footerSocial = "Footer-module--footer-social--3lTiq";
export var leapBanner = "Footer-module--leapBanner--KRUX9";